import React, { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 200);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div
      className="scroll-to-top scroll-to-target"
      onClick={scrollTop}
      style={{ display: visible ? 'flex' : 'none' }}
    >
      <span className="fa fa-arrow-up"></span>
    </div>
  );
}
